
export default {
  name: "BenefitCard",

  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    },
    icons: {
      type: Array,
      default: () => {
        return []
      }
    },
    isAnimate: {
      type: Boolean,
      default: false,
    },
    cardIndex: {
      type: Number,
      default: -1,
    },
  },

  data: function () {
    return {
      goAnimate: false
    }
  },

  computed: {
    icon: function () {
      return this.icons?.[this.item.icon] || null
    },
    plainTitle: function () {
      return `${(this.item?.title || '').replace(/<[^>]*>/g, ' ')}`.replace(/\s+/g, ' ').trim()
    },
    benefitCardPersonalAnimation: function () {
      let className = '';
      if (this.isAnimate && this.cardIndex === 0 && this.goAnimate) {
        className = '--animate-benefit-card-first';
      }
      if (this.isAnimate && this.cardIndex === 1 && this.goAnimate) {
        className = '--animate-benefit-card-second';
      }
      if (this.isAnimate && this.cardIndex === 2 && this.goAnimate) {
        className = '--animate-benefit-card-third';
      }
      if (this.isAnimate && this.cardIndex === 3 && this.goAnimate) {
        className = '--animate-benefit-card-fourth';
      }
      if (this.isAnimate && this.cardIndex === 4 && this.goAnimate) {
        className = '--animate-benefit-card-fifth';
      }
      if (this.isAnimate && this.cardIndex === 5 && this.goAnimate) {
        className = '--animate-benefit-card-sixth';
      }
      return className;
    },
  },

  watch: {
    isAnimate(newValue) {
      if (newValue && this.cardIndex > 2) {
        setTimeout(() => {
          this.goAnimate = true;
        }, 2500);
      } else {
        this.goAnimate = true;
      }
    }
  }
}
